<template>
  <q-section v-bind="$attrs" v-if="isShowBeInvited" :bg-i="uiMeta.images.teamBeInvitedEntry" @click="handleBeInvitedOpen()">
    <q-dialog name="beInvitedDialog" :bg-i="uiMeta.images.teamBeInvitedBg" pc="pc">
      <template #default="{ data }">
        <q-section v-bind="uiMeta.layout.wrapper.beInvitedDialogWrapper">
          <q-section style="width: 100%; height: 100%; overflow-y: auto; scrollbar-width: none">
            <q-section
              v-bind="uiMeta.layout.wrapper.beInvitedItemWrapper"
              :bg-i="uiMeta.images.teamInvitedMask"
              v-for="item in data?.inviteListData"
              :key="item.id">
              <q-section :bg-i="item.inviter.avatar_url" v-bind="uiMeta.layout.wrapper.beInvitedItemAvatarWrapper"></q-section>
              <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemNicknameWrapper" class="ws-nowrap">
                {{ item.inviter.nickname }}
              </q-section>
              <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemTextWrapper" class="ws-nowrap">
                {{ uiMeta.config.inviteText }}
              </q-section>
              <q-section
                v-bind="uiMeta.layout.wrapper.beInvitedItemButtonWrapper"
                :bg-i="uiMeta.images.teamButtonAgree"
                @click="acceptCpInviteData(item.invite_id)"></q-section>
            </q-section>
          </q-section>
        </q-section>
        <q-section v-bind="uiMeta?.layout?.wrapper?.closeBtnWrapper" @click="$dialogs.beInvitedDialog.close()"></q-section>
      </template>
    </q-dialog>
  </q-section>
</template>

<script setup lang="ts">
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
const { $dialogs } = useDialogs()
import { defaultConfig as uiMeta, useTeam } from './use-team'
const { acceptCpInviteData, handleBeInvitedOpen, isShowBeInvited } = useTeam(uiMeta, { mountInvitedDeepLink: true })
</script>

<style scoped lang="scss">
.be-invited-list {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
